import type { RuntimeStatus } from '@life-os/app-core';

/** Calm trust strip: local DB health, pending sync, conflicts, last sync. */
export function LocalFirstFooter({ status }: { status: RuntimeStatus }) {
  const dotState = status.localDb === 'ready' ? 'ready' : status.localDb;
  const synced =
    status.lastSyncAt === null ? 'Local only' : `Synced ${new Date(status.lastSyncAt).toLocaleTimeString()}`;
  return (
    <footer className="lc-footer">
      <span className="lc-footer__dot" data-state={dotState} />
      <span>
        Local DB: {status.localDb}
      </span>
      <span>· {status.pendingMutations} pending</span>
      {status.conflicts > 0 ? <span>· {status.conflicts} to review</span> : null}
      <span style={{ marginLeft: 'auto' }}>{synced}</span>
    </footer>
  );
}
